import script from "./basket.vue?vue&type=script&setup=true&lang=js"
export * from "./basket.vue?vue&type=script&setup=true&lang=js"

import "./basket.vue?vue&type=style&index=0&id=8448c684&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8448c684"]])

export default __exports__